
import * as storyblokRuntime$Jn57dC6nnd from '/home/runner/work/mad-storefront/mad-storefront/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as defaultRuntime$OzeeRV8b9w from '/home/runner/work/mad-storefront/mad-storefront/providers/default/index.ts'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1440,
    "3xl": 1680,
    "4xl": 1920
  },
  "presets": {},
  "provider": "default",
  "domains": [
    "a.storyblok.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$Jn57dC6nnd, defaults: {"baseURL":"https://a.storyblok.com","modifiers":{"quality":"85"}} },
  ['default']: { provider: defaultRuntime$OzeeRV8b9w, defaults: {"baseURL":"https://ags-live.cdn.aboutyou.cloud/"} }
}
        